function hasVoiceTags(text) {
  return /<v\s+[^>]+>/i.test(text);
}

function stripVoiceTags(text) {
  return String(text || "")
    .replace(/<v\s+[^>]+>/gi, "")
    .replace(/<\/v>/gi, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function parseTranscriptSegments(text) {
  const raw = String(text || "").trim();
  if (!raw) return [];

  if (!hasVoiceTags(raw)) {
    return [{ speaker: null, content: raw }];
  }

  const segments = [];
  const regex = /<v\s+([^>]+)>([\s\S]*?)<\/v>/gi;
  let match = regex.exec(raw);

  while (match) {
    const speaker = match[1].trim();
    const content = match[2].replace(/\s+/g, " ").trim();
    if (content) {
      segments.push({ speaker, content });
    }
    match = regex.exec(raw);
  }

  if (!segments.length) {
    const fallback = stripVoiceTags(raw);
    return fallback ? [{ speaker: null, content: fallback }] : [];
  }

  const merged = [];
  for (const segment of segments) {
    const last = merged[merged.length - 1];
    if (last?.speaker === segment.speaker) {
      last.content = `${last.content} ${segment.content}`;
    } else {
      merged.push({ ...segment });
    }
  }

  return merged;
}

export function formatTranscriptPreview(text) {
  const segments = parseTranscriptSegments(text);
  if (!segments.length) return "";

  const speakers = new Set(
    segments.map((segment) => segment.speaker).filter(Boolean),
  );

  if (speakers.size <= 1) {
    return segments.map((segment) => segment.content).join(" ");
  }

  return segments
    .map((segment) =>
      segment.speaker
        ? `${segment.speaker}: ${segment.content}`
        : segment.content,
    )
    .join(" ");
}
